export * from '~/utils/variables.c'

export const LoginType = {
  LOGIN: 'login',
  REG: 'register',
  RET: 'back',
}